<div class="sw-cms-el-moorl-replacer">
    <div>
        <p class="moorl-replacer-title">
            <mt-icon
                name="regular-repeat"
                size="24"
            />
            {{ $tc('sw-cms.elements.moorl-replacer.title') }}
        </p>
        <p>
            {{ $tc('sw-cms.elements.moorl-replacer.description') }}
        </p>
        <p>
            <a
                href="https://store.shopware.com/de/extension-partners/moori"
                target="_blank"
                rel="noopener"
            >
                {{ $tc('sw-cms.elements.moorl-replacer.storeLink') }}
            </a>
        </p>
    </div>
    <div>
        <sw-entity-single-select
            entity="moorl_cms_element_config"
            v-model:value="cmsElementConfigId"
            :placeholder="$tc('sw-cms.elements.moorl-replacer.label.selectConfig')"
        >
            <template #result-label-property="{ item }">
                {{ item.type }} | {{ item.name }}
            </template>
        </sw-entity-single-select>
    </div>
    <div>
        <mt-button
            :disabled="!cmsElementConfigId"
            square
            variant="primary"
            size="default"
            @click="onLoadCmsElementConfig"
        >
            <mt-icon
                name="regular-checkmark"
                size="16"
            />
        </mt-button>
    </div>
</div>